import { useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  AlertTriangle,
  Clock,
} from "lucide-react";
import Badge from "./Badge";

/* helper: build week range from date */
const getWeekRange = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d)) return "-";

  const start = new Date(d);
  start.setDate(d.getDate() - d.getDay());
  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  return `${start.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  })} - ${end.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })}`;
};

export default function ClaimCard({ data, onView , isRetailerMobile = false }) {
  const [expanded, setExpanded] = useState(false);

  const statusMap = {
    Approved: {
      badge: "green",
      accent: "border-l-emerald-500",
      meta: "Processed",
    },
    Rejected: {
      badge: "red",
      accent: "border-l-rose-500",
      meta: "Action required",
    },
    Pending: {
      badge: "yellow",
      accent: "border-l-amber-500",
      meta: "Under review",
    },
  };

  const status =
    statusMap[data.ui.status] || statusMap.Pending;

  return (
   <div
      className={`rounded-2xl p-4 mb-3 border-l-4 transition-all duration-300
        ${
          isRetailerMobile
            ? `bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)] ${status.accent}`
            : `border border-slate-200 bg-white shadow-sm ${status.accent}`
        }
      `}
    >
      {/* HEADER */}
      <div className="flex justify-between items-start gap-2">
        <div>
          <p
            className={`text-sm font-semibold ${
              isRetailerMobile ? "text-slate-900" : "text-slate-900"
            }`}
          >
            {data.ui.productName}
          </p>
          <p className={`text-[11px] ${
            isRetailerMobile ? "text-slate-700" : "text-slate-500"
          }`}>
            Claim ID: {data.ui.id}
          </p>

          <p className={`text-[11px] ${
            isRetailerMobile ? "text-slate-700" : "text-slate-500"
          }`}>
            Customer: {data.ui.registeredBy}
          </p>

        </div>

        <Badge label={data.ui.status} color={status.badge} />
      </div>

      {/* MAIN INFO */}
      <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
        <Info label="IMEI" value={data.ui.imei} />
        <Info
          label="Claim Date"
          value={data.ui.claimDate?.date}
        />

        {/* <Info
          label="Claim Week"
          value={getWeekRange(data.ui.claimDate?.raw)}
        /> */}

        
      </div>

      {/* META */}

        <div className="mt-2 flex justify-end items-center gap-1 text-[11px] text-sky-600 font-medium">
        {/* <div className="flex gap-1">
            <Clock size={13} />
            {status.meta}
        </div> */}

        <button
            onClick={() => setExpanded((p) => !p)}
            className="flex items-center gap-1 text-xs font-semibold text-blue-600"
          >
            {expanded ? "Less" : "More"}
            {expanded ? (
              <ChevronUp size={14} />
            ) : (
              <ChevronDown size={14} />
            )}
          </button>
      </div>


      {/* EXPANDED DETAILS */}
      {expanded && (
      <div
        className={`mt-3 pt-3 text-xs space-y-3
          ${
            isRetailerMobile
              ? "border-t border-white/30"
              : "border-t"
          }
        `}
      >
          {/* <Info label="Invoice" value={data.ui.saleInvoice} /> */}
          <Info label="Amount" value={`₹${data.ui.amount ?? "-"}`} />
          

          {data.ui.reasons?.length > 0 && (
            <div className="rounded-xl bg-amber-50 border border-amber-200 p-3">
              <div className="flex items-center gap-1 mb-2">
                <AlertTriangle size={14} className="text-amber-600" />
                <p className="text-[11px] font-semibold text-amber-700">
                  Claim Reasons
                </p>
              </div>

              <div className="max-h-20 overflow-y-auto pr-1 space-y-1 text-amber-800">
                {data.ui.reasons.map((r, i) => (
                  <p key={i}>• {r}</p>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* ACTION */}
      {onView && (
        <button
          onClick={onView}
          className="mt-3 w-full rounded-xl bg-blue-600 py-2 text-sm font-semibold text-white active:scale-[0.98]"
        >
          View Claim
        </button>
      )}
    </div>
  );
}

/* ---------- Small Info Block ---------- */
function Info({ label, value }) {
  return (
    <div>
      <p className="text-slate-500 font-medium">{label}</p>
      <p className="text-slate-800 font-semibold">
        {value || "-"}
      </p>
    </div>
  );
}


// import { ChevronRight, FileText, Clock } from "lucide-react";
// import Badge from "./Badge";

// /* helper: build week range from date */
// const getWeekRange = (dateStr) => {
//   if (!dateStr) return "-";

//   const d = new Date(dateStr);
//   if (isNaN(d)) return "-";

//   const start = new Date(d);
//   start.setDate(d.getDate() - d.getDay());

//   const end = new Date(start);
//   end.setDate(start.getDate() + 6);

//   return `${start.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//   })} - ${end.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   })}`;
// };

// export default function ClaimCard({ data, onView }) {
//   const statusColorMap = {
//     Approved: "green",
//     Rejected: "red",
//     Pending: "yellow",
//   };

//   const statusColor =
//     statusColorMap[data.ui.status] || "yellow";

//   return (
//     <div
//       onClick={onView}
//       className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm mb-3 active:bg-slate-50"
//     >
//       {/* TOP DATE */}
//       <div className="flex justify-between items-center text-xs text-slate-500 mb-2">
//         <span>{data.ui.claimDate?.date || "-"}</span>
//         <ChevronRight size={16} className="text-slate-400" />
//       </div>

//       {/* CLAIM ID + AMOUNT */}
//       <div className="flex justify-between items-center">
//         <div className="flex items-center gap-2 text-xs text-slate-700 font-medium">
//           <FileText size={14} />
//           <span>Claim ID :</span>
//           <span className="font-semibold text-slate-900">
//             {data.ui.id}
//           </span>
//         </div>

//         <div className="text-right">
//           <p className="text-[10px] text-slate-400">Amount</p>
//           <p className="text-sm font-semibold text-slate-900">
//             ₹{data.ui.amount ?? "-"}
//           </p>
//         </div>
//       </div>

//       {/* CLAIM WEEK */}
//       <div className="mt-2">
//         <p className="text-xs text-slate-500">Claim Week</p>
//         <p className="text-xs font-medium text-slate-800">
//           {getWeekRange(data.ui.claimDate?.raw)}
//         </p>
//       </div>

//       {/* META */}
//       <div className="mt-2 flex justify-between items-center">
//         <div className="flex items-center gap-1 text-[11px] text-sky-600 font-medium">
//           <Clock size={13} />
//           {data.ui.status === "Pending"
//             ? "Under review"
//             : data.ui.status === "Rejected"
//             ? "Action required"
//             : "Processed"}
//         </div>

//         <Badge label={data.ui.status} color={statusColor} />
//       </div>
//     </div>
//   );
// }




// import { useState } from "react";
// import { ChevronDown, ChevronUp, AlertTriangle } from "lucide-react";
// import Badge from "./Badge";

// export default function ClaimCard({
//   data,
//   onView,
//   hideExtra = false,
// }) {
//   const [expanded, setExpanded] = useState(false);

//   const statusMap = {
//     Approved: { badge: "green", accent: "border-l-emerald-500" },
//     Rejected: { badge: "red", accent: "border-l-rose-500" },
//     Pending: { badge: "yellow", accent: "border-l-amber-500" },
//   };

//   const status = statusMap[data.ui.status] || statusMap.Pending;

//   return (
//     <div
//       className={`rounded-2xl border border-slate-200 bg-white p-3 shadow-sm mb-3 border-l-4 ${status.accent}`}
//     >
//       {/* HEADER */}
//       <div className="flex justify-between items-start gap-2">
//         <div>
//           <p className="text-sm font-semibold text-slate-900">
//             {data.ui.productName}
//           </p>
//           <p className="text-[11px] text-slate-500">
//             Claim ID: {data.ui.id}
//           </p>
//         </div>

//         <Badge label={data.ui.status} color={status.badge} />
//       </div>

//       {/* MAIN INFO */}
//       <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
//         <Info label="Invoice" value={data.ui.saleInvoice} />
//         <Info label="IMEI" value={data.ui.imei} />

//         <Info
//           label="Claim Date"
//           value={data.ui.claimDate?.date}
//         />

//         <div className="flex items-end justify-end">
//           <button
//             onClick={() => setExpanded((p) => !p)}
//             className="flex items-center gap-1 text-xs font-semibold text-blue-600"
//           >
//             {expanded ? "Less" : "More"}
//             {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
//           </button>
//         </div>
//       </div>

//       {/* EXPANDED DETAILS */}
//       {expanded && !hideExtra && (
//         <div className="mt-3 border-t pt-3 space-y-3 text-xs">
//           {/* REASONS */}
//           {data.ui.reasons?.length > 0 && (
//             <div className="rounded-xl bg-amber-50 border border-amber-200 p-3">
//               <div className="flex items-center gap-1 mb-2">
//                 <AlertTriangle size={14} className="text-amber-600" />
//                 <p className="text-[11px] font-semibold text-amber-700">
//                   Claim Reasons
//                 </p>
//               </div>

//               <div className="max-h-20 overflow-y-auto pr-1 space-y-1 text-amber-800">
//                 {data.ui.reasons.map((r, i) => (
//                   <p key={i}>• {r}</p>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* CUSTOMER */}
//           <Info
//             label="Customer"
//             value={data.ui.registeredBy}
//           />
//         </div>
//       )}

//       {/* ACTION */}
//       {onView && (
//         <button
//           onClick={onView}
//           className="mt-3 w-full rounded-xl bg-blue-600 py-2 text-sm font-semibold text-white active:scale-[0.98]"
//         >
//           View Claim
//         </button>
//       )}
//     </div>
//   );
// }

// /* ---------- Small Info Block ---------- */
// function Info({ label, value }) {
//   return (
//     <div>
//       <p className="text-slate-500 font-medium">{label}</p>
//       <p className="text-slate-800 font-semibold">{value || "-"}</p>
//     </div>
//   );
// }
